// skills actions

export const ADD_SKILL = 'ADD_SKILL';
export const EDIT_SKILL = 'EDIT_SKILL';
export const SET_PRIORITIES = 'SET_PRIORITIES';
export const SET_QUALIFICATION = 'SET_QUALIFICATION';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_CODER_SKILL_LIST = 'SET_CODER_SKILL_LIST';
export const ADD_TOKEN = 'ADD_TOKEN';
export const DELETE_SKILL = 'DELETE_SKILL';

// Lead actions

export const SET_LEADS = 'SET_LEADS';
export const SET_SEARCH_LEADS = 'SET_SEARCH_LEADS';
export const SET_FUNNEL_TYPE = 'SET_FUNNEL_TYPE';
export const SET_FUNNEL_STATUS = 'SET_FUNNEL_STATUS';
export const SET_WORK_TECH = 'SET_WORK_TECH';
export const SET_WORK_TYPE = 'SET_WORK_TYPE';
export const SET_RESPONSIBLE = 'SET_RESPONSIBLE';
export const SET_LEAD_REDMINE_TO_EDIT = 'SET_LEAD_REDMINE_TO_EDIT';
export const SET_LEAD_TO_EDIT = 'SET_LEAD_TO_EDIT';
export const SET_NEW_LEAD_ID = 'SET_NEW_LEAD_ID';
export const SET_ACCOUNTS_OWNERS = 'SET_ACCOUNTS_OWNERS';
export const SET_PROPOSAL_TYPES = 'SET_PROPOSAL_TYPES';
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';
export const SET_LEADS_PER_PAGE = 'SET_LEADS_PER_PAGE';
export const SET_OFFSET = 'SET_OFFSET';
export const SET_POPUP_REDMINE = 'SET_POPUP_REDMINE';
export const SET_POPUP = 'SET_POPUP';
export const SET_TYPE_OF_POPUP_DATA = 'SET_TYPE_OF_POPUP_DATA';
export const SET_TYPE_OF_REDMINE_DATA = 'SET_TYPE_OF_REDMINE_DATA';
export const SET_UPDATE_NEW_LIST_LEADS_REDMINE_POPUP = 'SET_UPDATE_NEW_LIST_LEADS_REDMINE_POPUP';
export const SET_ISCHECKEXISTS = 'SET_ISCHECKEXISTS';

export const SET_EVENT_TYPES = 'SET_EVENT_TYPES';
export const GET_EVENTS_LIST = 'GET_EVENTS_LIST';
